import { render, staticRenderFns } from "./PosProductList.template.vue?vue&type=template&id=44232ebb&scoped=true&"
var script = {}
import style0 from "./PosProductList.template.vue?vue&type=style&index=0&id=44232ebb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44232ebb",
  null
  
)

export default component.exports